import { Deal } from '../../models/shared/Deal'
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useText } from '../../context/TextContext';
import { useFirestore } from 'reactfire';
import { doc, updateDoc, deleteField, deleteDoc } from 'firebase/firestore';
import { COLLECTIONS } from '../../utils/shared/constants';
import { useOrganization } from '../../context/OrganizationContext';
import { useSaveToast } from '../../context/SaveToastContext';
import DealContent from '../DealContent';
import { useFirebaseQuery } from '../../hooks/firebaseHooks';
import { Offer } from '../../models/shared/Offer';
import { Invoice } from '../../models/shared/Invoice';

interface Props {
    deal: Deal;
    initialFocus?: 'name'
    onClose: () => void;
    onDealStepChange?: (dealId: string, stepId: string) => Promise<void>;
    onDealArchive?: (deal: Deal) => void
}

let timeout: NodeJS.Timeout | null = null;

interface UpdateDealOptions {
    noSaveToast?: boolean
}

function DealModal(props: Props) {
    const { deal } = props
    const { orgId } = useOrganization();
    const dealId = deal.id || '';
    const text = useText();
    const firestore = useFirestore();
    const { markSaved, startSaving } = useSaveToast();
    const [offers] = useFirebaseQuery<Offer>(`${COLLECTIONS.ORGANIZATIONS}/${orgId}/${COLLECTIONS.DEALS}/${dealId}/${COLLECTIONS.OFFERS}`);
    const [invoices] = useFirebaseQuery<Invoice>(`${COLLECTIONS.ORGANIZATIONS}/${orgId}/${COLLECTIONS.DEALS}/${dealId}/${COLLECTIONS.INVOICES}`);

    const updateDeal = async (update: Partial<Deal>, options: UpdateDealOptions = {}) => {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(async () => {
            try {
                let saveId = 0
                if (!options.noSaveToast) {
                    saveId = startSaving();
                }

                const dealRef = doc(firestore, `${COLLECTIONS.ORGANIZATIONS}/${orgId}/${COLLECTIONS.DEALS}/${dealId}`);
                update.updatedAt = new Date();

                await updateDoc(dealRef, { ...update, brandNew: deleteField() });

                if (!options.noSaveToast) {
                    markSaved(saveId);
                }
            } catch (error) {
                console.log('Error updating deal', error)
                toast.error(text.defaultError)
            }
        }, 1000);
    }

    const handleClose = () => {
        if (deal.brandNew) {
            const dealRef = doc(firestore, `${COLLECTIONS.ORGANIZATIONS}/${orgId}/${COLLECTIONS.DEALS}/${dealId}`);
            deleteDoc(dealRef);
        }
        props.onClose();
    }

    return <Modal show={true} onHide={handleClose} size='xl' style={{ maxWidth: '100vw' }} backdrop="static">
        <DealContent
            deal={deal}
            offers={offers}
            invoices={invoices}
            onDealUpdate={updateDeal}
            initialFocus={props.initialFocus}
            onClose={handleClose}
            onDealArchive={props.onDealArchive}
            onDealStepChange={props.onDealStepChange}
        />
    </Modal>
}

export default DealModal
